
<template>
  <g class="not-copy" @mouseup="saveScenario" @dblclick="openEdit" @contextmenu.prevent="openContextMenu">
    <!-- 選択時の枠 -->
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset"
      :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="messageBoxX + 10" :height="messageBoxY + 10" :rx="rxSize"
      v-if="(isMoveScenario || multiSelected)"></rect>
    <!-- Message -->
    <!-- ロボロック解除時 -->
    <rect :fill="bgColorBlue"  :x="Number(scenario.beforenodeX)" :y="scenario.beforenodeY" :width="messageBoxX" :height="messageBoxY" :rx="rxSize"
      @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" @mousedown="moveScenario" v-if="!selectChatbot.is_confirm"></rect>
    <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 5" :y="Number(scenario.beforenodeY) + 5" :width="messageBoxX-10" :height="messageBoxY-10" :rx="rxSize"
      @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" @mousedown="moveScenario" v-if="!selectChatbot.is_confirm"></rect>
    <text v-for="(mes, i) in textAry" :key="i"
      :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 10" :y="Number(scenario.beforenodeY) + 30 + i*25"
      @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" @mousedown="moveScenario" v-if="!selectChatbot.is_confirm">
      {{mes}}</text>
    <rect class="resize" :fill="'#FF0000'" :x="Number(scenario.beforenodeX) + messageBoxX - 15" :y="Number(scenario.beforenodeY) + messageBoxY - 15" :width="15" :height="15"
      @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" @mousedown="resizeScenario" v-if="!selectChatbot.is_confirm"></rect>
    <!-- ロボロック時 -->
    <rect :fill="bgColorBlue"  :x="Number(scenario.beforenodeX)" :y="scenario.beforenodeY" :width="messageBoxX" :height="messageBoxY" :rx="rxSize"
      @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" v-if="selectChatbot.is_confirm"></rect>
    <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 5" :y="Number(scenario.beforenodeY) + 5" :width="messageBoxX-10" :height="messageBoxY-10" :rx="rxSize"
      @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" v-if="selectChatbot.is_confirm"></rect>
    <text v-for="(mes, i) in textAry" :key="i"
      :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 10" :y="Number(scenario.beforenodeY) + 30 + i*25"
      @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" v-if="selectChatbot.is_confirm">
      {{mes}}</text>
    <rect class="no-resize" :fill="'#FF0000'" :x="Number(scenario.beforenodeX) + messageBoxX - 15" :y="Number(scenario.beforenodeY) + messageBoxY - 15" :width="15" :height="15"
      @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" v-if="selectChatbot.is_confirm"></rect>
  </g>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import hex2rgb from '@/functions/hex2rgb'
import alterReplace from '@/functions/alterStrReplace'
import makeUpdateTemplateData from '@/functions/makeUpdateTemplateData'

export default {
  name: 'ScenarioGroup',
  componentName: 'ScenarioGroup',
  props: ['scenario', 'colors', 'ratio', 'dx', 'dy', 'multiSelectedParts', 'isMultiPartsMove', 'multiPartsRelativePos'],
  computed: {
    ...mapState('chatbot', ['selectChatbot', 'scenarioTable', 'chatbots', 'scenarioName', 'isSCNLoading', 'modalScenario', 'scenarioNodeData', 'isRoboPartsSetView', 'isLoadingScenarioKPI', 'scenarioKPI', 'detail', 'bluePrintInfo', 'selectTemplateId']),
    ...mapState('auth', ['botstatus', 'user']),
    multiSelected () {
      return Boolean(this.multiSelectedParts.filter((item) => item.beforenode == this.scenario.beforenode).length)
    },
    textAry () {
      const num = Math.floor((this.messageBoxX - 20) / 16)
      const rowNum = Math.floor((this.messageBoxY - 10) / 25)
      let m = this.scenario.mainmessage
      m = m ? alterReplace(m, true) : m
      m = m.replace('[memo]', '').replace('[/memo]', '')

      const re = new RegExp('.{1,'+num+'}', 'g')
      let rows = m.split('\n')
                  .map((str) => {if (str.length==0) str=' ';return str.match(re)})
                  .reduce((pre, cur) => {pre.push(...cur);return pre},[])
      if (rows.length > rowNum) {
        rows = rows.slice(0, rowNum)
        if (rows[rows.length-1].length == num)rows[rows.length-1] = rows[rows.length-1].substring(0, rows[rows.length-1].length-1)
        rows[rows.length-1] += '…'
      }
      return rows.slice(0,rowNum)
    }
  },
  components: {
    alterReplace
  },
  data () {
    return {
      isMoveScenario: false,
      beforeMouseX: null,
      beforeMouseY: null,
      bgColorWhite: '#f8f8f8',
      bgColorBlue: '#666',
      bgColorGray: '#c0c0c0',
      bgColorFont: '#000',
      rxSize: 5,
      fontSize: '12px',
      cursorColor: '#99CCFF',
      cursorDasfOffset: 0,
      cursorDasfArray: 5,
      messageBoxX: 200,
      messageBoxY: 45,
      isMouseout: false,
      isOver: false,
      isMouseMove: false,
      resizeOrig: false,
    }
  },
  mounted () {
    document.addEventListener('mouseup', this.mouseUp)
    document.addEventListener('mousemove', this.mouseMove)
    document.addEventListener('click', (e) => {
      if (!e.target.closest('not-copy')) {
        this.closeContextMenu()
      }
    })
    if (this.scenario.parameter.width) this.messageBoxX = this.scenario.parameter.width
    if (this.scenario.parameter.height) this.messageBoxY = this.scenario.parameter.height
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.mouseUp)
    document.removeEventListener('mousemove', this.mouseMove)
    document.removeEventListener('click', this.closeContextMenu)
  },
  watch: {
    isMultiPartsMove () {
      if (!this.multiSelected) return
      if (this.isMultiPartsMove) {
        this.isMoveScenario = true
      } else {
        this.saveScenario()
      }
    },
  },
  methods: {
    overMouse (event, flg, msg) {
      this.isOver = flg
      var isUp = (window.innerHeight - event.clientY > 155) ? true : false
      msg = msg ? alterReplace(msg, true) : msg
      this.$store.dispatch('chatbot/detail', {msg: msg, isUp: isUp})
    },
    mouseOut (event) {
      this.isMouseout = true
    },
    subMessage (m, num) {
      m = m ? alterReplace(m, true) : m
      m = m.replace('[memo]', '').replace('[/memo]', '')
      if (m.indexOf('\n') === -1) return m.length < num ? m : m.substring(0, num - 3) + '...'
      else {
        var w = m.replace('\n', '')
        return w.length < num ? m : w.substring(0, num - 3) + '...'
      }
    },
    moveScenario (event) {
      event.preventDefault()
      const selectedFlg = this.multiSelected
      if (event.shiftKey) {
        this.$emit('multiSelect', this.scenario)
        if (selectedFlg) return
      } else if (!this.multiSelected) {
        this.$emit('multiDeselectAll')
      }
      this.isMoveScenario = true
      if (this.multiSelected) this.$emit('multiMove', true)
      this.$store.dispatch('chatbot/setBluePrintInfoFlg', true)
      this.$store.dispatch('chatbot/dragScroll', false)
    },
    resizeScenario (event) {
      event.preventDefault()
      this.resizeOrig = {sizeX: this.messageBoxX, sizeY: this.messageBoxY, mouseX: event.screenX, mouseY: event.screenY}
      this.$store.dispatch('chatbot/dragScroll', false)
    },
    mouseUp (event) {
      if (this.multiSelected) this.$emit('multiMove', false)
      this.isMoveScenario = false
      this.beforeMouseX = null
      this.beforeMouseY = null
      this.isMouseout = false
      event.preventDefault()
    },
    mouseMove (event) {
      if (this.resizeOrig) {
        this.messageBoxX = Math.max(200, this.resizeOrig.sizeX + (event.screenX - this.resizeOrig.mouseX)*this.ratio)
        this.messageBoxY = Math.max(45, this.resizeOrig.sizeY + (event.screenY - this.resizeOrig.mouseY)*this.ratio)
      }

      if (!this.isMoveScenario) return
      var mouseX = event.offsetX * this.ratio + this.dx
      var mouseY = event.offsetY * this.ratio + this.dy

      this.isMouseMove = true

      //移動可能な範囲外にマウスが出た
      if (event.clientX < 400 || event.clientX > 400+this.bluePrintInfo.width || event.clientY < 130 || event.clientY > 130 + this.bluePrintInfo.height - 5) {
        this.isMouseout = true
        this.isMoveScenario = false
        this.saveScenario()
        return
      }

      var dx = 0
      var dy = 0
      if (this.beforeMouseX && this.beforeMouseY) {
          dx = mouseX - this.beforeMouseX
          dy = mouseY - this.beforeMouseY
      }
      this.beforeMouseX = mouseX
      this.beforeMouseY = mouseY
      var tempX = 0
      var tempY = 0
      // 動かす場合
      tempX = dx + Number(this.scenario.beforenodeX)
      tempY = dy + Number(this.scenario.beforenodeY)

      const compareTop = tempY + (this.multiSelected ? this.multiPartsRelativePos[this.scenario.beforenode].top : 0)
      const compareBottom = tempY + (this.multiSelected ? this.multiPartsRelativePos[this.scenario.beforenode].bottom : 0)
      const compareLeft = tempX + (this.multiSelected ? this.multiPartsRelativePos[this.scenario.beforenode].left : 0)
      const compareRight = tempX + (this.multiSelected ? this.multiPartsRelativePos[this.scenario.beforenode].right : 0)

      if (!this.isMouseout) {
        if ((dx > 0 && compareRight < (this.bluePrintInfo.scrollX+this.bluePrintInfo.width-150)*this.ratio)
        || (dx < 0 && compareLeft > this.bluePrintInfo.scrollX*this.ratio)) this.scenario.beforenodeX = tempX
        if ((dy > 0 && compareBottom < (this.bluePrintInfo.scrollY+this.bluePrintInfo.height-20)*this.ratio)
        || (dy < 0 && compareTop > this.bluePrintInfo.scrollY*this.ratio)) this.scenario.beforenodeY = tempY
      }

      event.preventDefault()
    },
    openEdit (event) {
      if (event.shiftKey) return
      else this.$emit('multiDeselectAll')
      this.$store.dispatch('chatbot/selectScenario', this.scenario)
      this.$store.dispatch('chatbot/changeModalEditScenario')
    },
    openContextMenu (event) {
      if (event.shiftKey) return
      else this.$emit('multiDeselectAll')
      var menu = document.getElementById("context-menu")
      if(!this.contextMenuWidth || !this.contextMenuHeight) {
        menu.style.visibility = 'hidden'
        menu.style.display = 'block'
        this.contextMenuWidth = menu.offsetWidth
        this.contextMenuHeight = menu.offsetHeight
        menu.removeAttribute('style')
      }

      if ((this.contextMenuWidth + event.pageX) >= window.innerWidth) {
        menu.style.left = (event.pageX - this.contextMenuWidth) + 'px'
      } else {
        menu.style.left = event.pageX + 'px'
      }
      if ((this.contextMenuHeight + event.clientY) >= window.innerHeight) {
        menu.style.top = (event.clientY - this.contextMenuHeight) + 'px'
      } else {
        menu.style.top = event.clientY + 'px'
      }
      let isCopy = Boolean(Number(localStorage.getItem('SCENARIO_IS_COPY')))
      let isCut = Boolean(Number(localStorage.getItem('SCENARIO_IS_CUT')))
      this.$store.dispatch('chatbot/setPasteFlg', Boolean(isCopy || isCut), isCopy, isCut)
      menu.classList.add('active')
      this.$store.dispatch('chatbot/selectScenario', this.scenario)
    },
    closeContextMenu () {
      let contextMenu = document.getElementById('context-menu')
      if (contextMenu) {
        contextMenu.classList.remove('active')
      }
    },
    saveScenario () {
      if (!this.isRoboPartsSetView) {
        if (this.isMouseMove || this.resizeOrig) {
          if (toString.call(this.scenario.parameter) != '[object Object]') this.scenario.parameter = {}
          this.scenario.parameter.width = this.messageBoxX
          this.scenario.parameter.height = this.messageBoxY
          this.$store.dispatch('chatbot/setScenario', { companyid: this.user.companyID, scenarioName: this.scenario.name, scenario: this.scenario})
            .then(() => {
              this.setEditStatus(this.selectChatbot.bot_id, this.user.userHash, this.scenario.pk)
            })
          this.isMouseMove = false
        }
      }
      this.resizeOrig = null
      this.$store.dispatch('chatbot/dragScroll', true)
    },
    setEditStatus (botID, userHash, scenarioID) {
      // ロボの編集情報を送信
      let editData = {
        'uuid'       : userHash,
        'bot_id'     : botID,
        'scenario_id': scenarioID,
      }
      this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
        '[SETSCENARIO]' + JSON.stringify(editData)
      )
    }
  }
}
</script>

<style scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
}
.resize {
  cursor: nwse-resize;
}
.no-resize {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ScenarioMemo.vue